import Vue from 'vue'
import Router from 'vue-router' 
import Home from '@/page/Home'
import proHome from '@/page/proHome'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/prohome',
      name: 'prohome',
      component: proHome
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js